// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".emoji-panel[data-v-94c2be08]{right:0;bottom:calc(100% + 1.5rem)}.fade-enter-active[data-v-94c2be08],.fade-leave-active[data-v-94c2be08]{transition:opacity .3s ease}.fade-enter[data-v-94c2be08],.fade-leave-to[data-v-94c2be08]{opacity:0}.emoji-container[data-v-94c2be08]{max-height:256px}.emoji-item[data-v-94c2be08]{padding:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
